import { sharedDividirNoAsignadasPorPeso } from "./shared-distribucion-no-asignados";

export const sharedDistribuirPedidosPorConfiguracion = (rowsData, opcionesAvanzadas) => {
    try {
        console.log('rowsData');
        console.log(rowsData);
        console.log('opcionesAvanzadas');
        console.log(opcionesAvanzadas);
        // const resultado = distributeDeliveries(rowsData, {
        //     listaUnidadesActivas: opcionesAvanzadas.listaUnidadesActivas,
        //     switchAsignarPorPeso: opcionesAvanzadas.switchAsignarPorPeso,
        //     switchUsarVehiculoSoloUnaVez: opcionesAvanzadas.switchUsarVehiculoSoloUnaVez
        // });
        // console.log('resultado');
        // console.log(resultado);
        if (opcionesAvanzadas.switchUsarVehiculoDelExcel === true) {
            return { error: false, data: rowsData };
        }
        const agrupadoPorNumeroDocumento = agruparPorNumeroDocumento(rowsData);
        const agrupadoConPeso = agregarPesoTotalPorDocumento(agrupadoPorNumeroDocumento);

        const resultado = asignarDocumentosAVehiculosPorPeso(
            agrupadoConPeso,
            opcionesAvanzadas
        );

        console.log('resultado');
        console.log(resultado);

        const noAsignadasIsEmpty = isObjectEmpty(resultado.noAsignadas);

        console.log('noAsignadasIsEmpty', noAsignadasIsEmpty);

        const noAsignadas = resultado.noAsignadas;
        console.log('noAsignadas', noAsignadas);

        if (noAsignadasIsEmpty === true) {
            //distribuir el vehiculo seleccionado en cada numero documento
            return { error: false, data: rowsData };
        }

        if (noAsignadasIsEmpty === false && opcionesAvanzadas.switchDividirSiNoSeEncuentraVehiculo === true) {
            const resultadoDividirNoAsignadasPorPeso = sharedDividirNoAsignadasPorPeso({
                noAsignadas,
                listaUnidadesActivas: opcionesAvanzadas.listaUnidadesActivas,
                usarVehiculoSoloUnaVez: false
            });
            console.log('resultadoDividirNoAsignadasPorPeso');
            console.log(resultadoDividirNoAsignadasPorPeso);
        }

        return { error: false, data: rowsData };
    } catch (err) {
        console.log('sharedDistribuirPedidosPorConfiguracion err');
        console.log(err);
        return { error: true, message: err };
    }
};

const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;

    const number = Number(String(value).replace(",", "."));

    return Number.isFinite(number) ? number : 0;
};

const agruparPorNumeroDocumento = (listaEntregas = []) => {
    return listaEntregas.reduce((acc, item) => {
        const key = String(item.numeroDocumento);

        if (!acc[key]) {
            acc[key] = [];
        }

        acc[key].push(item);

        return acc;
    }, {});
};

const agregarPesoTotalPorDocumento = (agrupado = {}) => {
    return Object.entries(agrupado).reduce((acc, [numeroDocumento, productos]) => {
        const pesoTotal = productos.reduce((total, producto) => {
            return total + toNumber(producto.peso);
        }, 0);

        acc[numeroDocumento] = {
            pesoTotal,
            productos
        };

        return acc;
    }, {});
};

const prepararVehiculos = (listaUnidadesActivas = []) => {
    return listaUnidadesActivas.map((vehiculo) => ({
        ...vehiculo,
        pesoMaximo: toNumber(vehiculo.peso),
        pesoDisponible: toNumber(vehiculo.peso),
        usado: false
    }));
};

const buscarVehiculoDisponible = ({
    vehiculos,
    pesoNecesario,
    usarVehiculoSoloUnaVez
}) => {
    return vehiculos.find((vehiculo) => {
        if (vehiculo.pesoDisponible < pesoNecesario) return false;

        if (usarVehiculoSoloUnaVez && vehiculo.usado) return false;

        return true;
    });
};

const asignarDocumentosAVehiculosPorPeso = (documentosAgrupados = {}, parametros = {}) => {
    const vehiculos = prepararVehiculos(parametros.listaUnidadesActivas);
    console.log('vehiculos');
    console.log(vehiculos);
    const asignadas = {};
    const noAsignadas = {};

    for (const [numeroDocumento, dataDocumento] of Object.entries(documentosAgrupados)) {
        const pesoTotal = toNumber(dataDocumento.pesoTotal);

        const vehiculoEncontrado = buscarVehiculoDisponible({
            vehiculos,
            pesoNecesario: pesoTotal,
            usarVehiculoSoloUnaVez: parametros.switchUsarVehiculoSoloUnaVez
        });

        if (!vehiculoEncontrado) {
            noAsignadas[numeroDocumento] = {
                ...dataDocumento,
                motivo: `No hay vehículo disponible para cargar ${pesoTotal}`
            };

            continue;
        }

        asignadas[numeroDocumento] = {
            ...dataDocumento,
            vehiculoAsignado: {
                id: vehiculoEncontrado.id,
                placa: vehiculoEncontrado.labelPlaca,
                conductor: vehiculoEncontrado.nombreConductor,
                pesoMaximo: vehiculoEncontrado.pesoMaximo
            }
        };

        vehiculoEncontrado.pesoDisponible -= pesoTotal;
        vehiculoEncontrado.usado = true;
    }

    return {
        asignadas,
        noAsignadas,
        vehiculos
    };
};

const isObjectEmpty = (obj) => {
    return obj !== undefined &&
        obj !== null &&
        typeof obj === "object" &&
        !Array.isArray(obj) &&
        Object.keys(obj).length === 0;
};